import { useDocumentVisibility } from '@vueuse/core'

export function usePageViewTracker() {
  const { track } = useAnalytics()
  const pageVisibility = useDocumentVisibility()
  let reload = true

  watch(
    pageVisibility,
    (current) => {
      if (current === 'visible' && reload) {
        track('NtpPage_Viewed')
        reload = false
      }
    },
    { immediate: true }
  )
}
